import React, { useState } from "react";
import cross_icon from "../../assets/icons/cross_icon.png";
import attachment_pin_icon from "../../assets/icons/attachment_pin_icon.png";

let email = `Subject: Join Us for Our Exclusive Exhibition!
Dear [User's Name],
We are thrilled to invite you to our upcoming exhibition showcasing the latest in [Industry/Theme]! Your presence would add tremendous value to this exciting event, and we would be honored to have you join us.

Event Details:
Date: Saturday, March 5th, 2024
Time: 10:00 AM - 5:00 PM
Venue: [Venue Name], [Address]

About the Exhibition:Our exhibition aims to celebrate innovation and creativity in [Industry/Theme]. From cutting-edge technologies to thought-provoking artworks, our curated collection promises to inspire and captivate audiences. As a distinguished member of our community, your insights and feedback would be invaluable in shaping the discourse surrounding our exhibits.

Thank you for considering our invitation. We genuinely hope you can join us for this special occasion!
Warm regards,
[Your Name][Your Position/Title][Your Contact Information]|`;

const EditEmailTemplate = ({
  setShowEditEmailModal,
  setShowRescheduledTask,
}) => {
  const [emailText, setEmailText] = useState(email);

  const handleCloseEditModal = () => {
    setShowEditEmailModal(false);
  };

  const handleSaveEmailEdit = () => {
    setShowEditEmailModal(false);
    setShowRescheduledTask(true);
  };
  const handleChange = (event) => {
    setEmailText(event.target.value);
  };
  return (
    <>
      <div className="modal-wrapper overflow-y-auto ">
        <div className="side-modal w-[40%]">
          <div className="flex mt-10 mb-8 justify-center">
            <div className="flex w-[80%] justify-between">
              <p className="text-[#2F80ED] text-[20px]">
                Editing Email Template
              </p>
              <div onClick={handleCloseEditModal} className="cursor-pointer">
                <img src={cross_icon} alt="cross icon" />
              </div>
            </div>
          </div>
          <div className="flex justify-center">
            <div className="w-[90%] flex h-[30rem]">
              <div className="border border-black w-full rounded-xl">
                <textarea
                  className="w-full h-[25rem] p-6 rounded-xl"
                  value={emailText}
                  onChange={handleChange}
                />
                <div className="flex items-center mt-4 p-2">
                  <img src={attachment_pin_icon} alt="attachments" />
                  <p className="text-[#828282] text-[14px] ml-2">
                    Attachment for invite
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center text-[14px] mt-10">
            <div className="w-[90%] flex justify-between mb-36">
              <div
                className="border border-[#2F80ED] w-[49%] p-2 rounded-lg flex justify-center cursor-pointer"
                onClick={handleSaveEmailEdit}
              >
                <button>Discord</button>
              </div>
              <div
                className="bg-[#2F80ED] text-white w-[49%] p-2 rounded-lg flex justify-center cursor-pointer"
                onClick={handleSaveEmailEdit}
              >
                <button>Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditEmailTemplate;
